// extracted by mini-css-extract-plugin
export default {"detailTitleBox":"DetailTitle_detailTitleBox__zas+n"};